import axios from 'axios'
import { Message } from 'element-ui';

const service = axios.create({
  baseURL: 'https://travel.cnsuheng.com/api/', 
  // baseURL: '/hkkapi', 
  
  timeout: 10000 
})

service.interceptors.request.use(
  config => {
    
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    console.log('请求错误:', error)
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200 && res.code !== 0) {
      // 显示错误提示
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      
      // 特殊状态码处理
      if (res.code === 508 || res.code === 512 || res.code === 514) {
        // 登出操作
        // 清除token
        localStorage.removeItem('token')
        sessionStorage.removeItem('token')
        // 跳转到登录页
        window.location.href = '/login'
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // 对响应错误做点什么
    let message = ''
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          message = '请求错误(400)'
          break
        case 401:
          message = '未授权，请重新登录(401)'
          window.location.href = '/login'
          break
        case 403:
          message = '拒绝访问(403)'
          break
        case 404:
          message = '请求出错(404)'
          // window.location.href = '/login'
          break
        case 408:
          message = '请求超时(408)'
          break
        case 500:
          message = '服务器错误(500)'
          break
        case 501:
          message = '服务未实现(501)'
          break
        case 502:
          message = '网络错误(502)'
          break
        case 503:
          message = '服务不可用(503)'
          break
        case 504:
          message = '网络超时(504)'
          break
        case 505:
          message = 'HTTP版本不受支持(505)'
          break
        default:
          message = `连接出错(${error.response.status})!`
      }
    } else {
      message = '连接服务器失败!'
    }
    
    // 显示错误提示
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    
    return Promise.reject(error)
  }
)

/**
 * 通用请求方法
 * @param {Object} config 请求配置
 * @returns {Promise} Promise对象
 */
function request(config) {
  return service(config)
}

/**
 * GET请求
 * @param {string} url 请求地址
 * @param {Object} params 请求参数
 * @param {Object} config 额外配置
 * @returns {Promise} Promise对象
 */
function get(url, params = {}, config = {}) {
  return service({
    url,
    method: 'get',
    params,
    ...config
  })
}

/**
 * POST请求
 * @param {string} url 请求地址
 * @param {Object} data 请求数据
 * @param {Object} config 额外配置
 * @returns {Promise} Promise对象
 */
function post(url, data = {}, config = {}) {
  return service({
    url,
    method: 'post',
    data,
    ...config
  })
}

/**
 * PUT请求
 * @param {string} url 请求地址
 * @param {Object} data 请求数据
 * @param {Object} config 额外配置
 * @returns {Promise} Promise对象
 */
function put(url, data = {}, config = {}) {
  return service({
    url,
    method: 'put',
    data,
    ...config
  })
}

/**
 * DELETE请求
 * @param {string} url 请求地址
 * @param {Object} params 请求参数
 * @param {Object} config 额外配置
 * @returns {Promise} Promise对象
 */
function del(url, params = {}, config = {}) {
  return service({
    url,
    method: 'delete',
    params,
    ...config
  })
}

/**
 * 上传文件请求
 * @param {string} url 请求地址
 * @param {FormData} formData 表单数据
 * @param {Function} onProgress 上传进度回调
 * @param {Object} config 额外配置
 * @returns {Promise} Promise对象
 */
function upload(url, formData, onProgress = null, config = {}) {
  return service({
    url,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const percent = (progressEvent.loaded / progressEvent.total) * 100
        onProgress(percent)
      }
    },
    ...config
  })
}

// 导出所有方法
export default {
  request,
  get,
  post,
  put,
  delete: del,
  upload
}